import Dedicated from './Dedicated';

export default Dedicated;
